<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="form" :model="form" label-width="150px" :inline="true">
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCard"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input
            v-model="form.phone"
            placeholder="请输入用户电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="归属企业">
          <el-select
            clearable
            v-model="form.company"
            filterable
            placeholder="全部"
          >
            <el-option
              v-for="v in companyIdArr"
              :key="v.id"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="form.region"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <btns class="mgb-20" @exec="exec"></btns>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="waterCard" label="水卡编号"> </el-table-column>
      <el-table-column prop="name" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 2
                ? '实物卡'
                : scope.row.cardType == 3
                ? '时效电子卡'
                : scope.row.cardType == 4
                ? '时效实物卡'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="companyName" label="归属企业"> </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <el-table-column prop="address" label="是否绑定">
        <template slot-scope="scope">
          <span v-text="scope.row.userId ? '已绑定' : '未绑定'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="用户电话">
        <template slot-scope="scope">
          <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="初审状态">
        <template slot-scope="scope">
          <span>已通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="复审状态">
        <template slot-scope="scope">
          <span>已通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="终审状态">
        <template slot-scope="scope">
          <span>待审核</span>
        </template>
      </el-table-column>
      <el-table-column prop="applyTime" label="申请时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 审核弹框 -->
    <el-dialog
      title="操作提示"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="30vh"
    >
      <div class="center mgb-10" v-if="funTit == 'pass'">
        审核通过后系统将对水卡余额清零，确定通过水卡清零申请吗?
      </div>
      <div class="center mgb-10" v-else>确定驳回水卡清零申请吗?</div>

      <el-form ref="checkForm" :model="checkForm" label-width="80px">
        <el-form-item label="审核备注">
          <el-input
            type="textarea"
            v-model="checkForm.desc"
            placeholder="请输入审核备注"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="checkBtn">{{
          funTit == "pass" ? "通 过" : "驳 回"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      companyIdArr: [],
      zoneArr: [],
      tableData: [],
      multipleSelection: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      funTit: null,
      dialogVisible: false,
      checkForm: {
        desc: "",
      },
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getcompanyId();
    this.getZone();
    this.getList();
  },
  methods: {
    handleDetail(row) {
      this.$router.push({
        path: "/cardClearZero/detail",
        query: {
          id: row.id,
          type: 3,
        },
      });
    },
    checkBtn() {
      handleConfirm(
        `确定${this.funTit == "pass" ? "通过" : "驳回"}该申请吗?`,
        "info"
      )
        .then(() => {
          this.$api.waterCard
            .cardClearZeroCheck({
              id: this.multipleSelection[0].id,
              msg: this.checkForm.desc ? this.checkForm.desc : "- -",
              state: this.funTit == "pass" ? 1 : 2,
              type: 3,
            })
            .then((res) => {
              if (res.code === 200) {
                handleAlert(
                  `${
                    this.funTit == "pass"
                      ? "水卡清零终审已通过，系统将自动对水卡余额清零"
                      : "水卡清零终审已驳回"
                  }`,
                  "success"
                );
                this.getList();
                this.dialogVisible = false;
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    // 通过
    pass() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.checkForm = {
        desc: "",
      };
      this.dialogVisible = true;
    },

    // 驳回
    turndown() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.checkForm = {
        desc: "",
      };
      this.dialogVisible = true;
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .cardClearZeroList({
          type: 3,
          pageNum: this.page,
          pageSize: this.pageSize,
          waterCard: this.form.waterCard,
          phone: this.form.phone,
          companyId: this.form.company,
          regionId: this.form.region,
          beginTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    getZone() {
      this.$api.order.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    getcompanyId() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        if (res.code === 200) {
          this.companyIdArr = res.data;
        }
      });
    },

    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
